import styles from "../../../../assets/styles/componentStyles/billingStyles/billing.module.scss";
import { toCapitalizedCase } from "../../../../utils/constants";

const STATUS_MAP_STYLE = {
    captured: styles.statusActive,
    active: styles.statusActive,
    paid: styles.statusActive,
    public: styles.statusActive,

    created: styles.statusCreated,
    private: styles.statusCreated,

    archived: styles.statusArchived,

    authorized: styles.statusAutheticated,
    authenticated: styles.statusAutheticated,
    
    pending: styles.statusPending,
    
    halted: styles.statusHalted,
    
    failed: styles.statusCancelled,
    cancelled: styles.statusCancelled,
    
    completed: styles.statusCompleted,
    
    refunded: styles.statusExpired,
    expired: styles.statusExpired,
};

const hasDisplayableStatus = (status: string) => {
    if (status == null) {
        return false;
    }

    const normalizedStatus = String(status).trim();
    return normalizedStatus !== '' && normalizedStatus !== '-';
};

const StatusChip = ({ status }: { status: string }) => {
    if (!hasDisplayableStatus(status)) {
        return "-";
    }

    const normalizedStatus = status.toLowerCase();
    const statusClass = STATUS_MAP_STYLE[normalizedStatus as keyof typeof STATUS_MAP_STYLE] || styles.statusDefault;

    return (
        <span className={`${styles.statusChip} ${statusClass}`}>
            <span className={styles.statusDot} />
            {toCapitalizedCase(status)}
        </span>
    );
};

export default StatusChip;
